module.exports = __webpack_public_path__ + "r-v3/img/set_more.a86e6102.svg";